import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import {
	AutoCompleteItem as DropdownAutoCompleteItem,
	Dropdown,
} from "@/components/Dropdown/Dropdown";
import { Information } from "@/components/Information/Information";

import {
	HubspotDealCreationTrigger,
	HubspotDealCreationTriggerWithInherit,
} from "../../../../Company/schema/hubspot";

interface HubspotDealCreationSectionProps {
	isHubspotEnabled: boolean;
	isConnected: boolean;
	selectedDealCreationTrigger: HubspotDealCreationTriggerWithInherit | undefined;
	setSelectedDealCreationTrigger: (trigger: HubspotDealCreationTriggerWithInherit) => void;
	effectiveTrigger: HubspotDealCreationTrigger | undefined;
}

export const HubspotDealCreationSection: FunctionComponent<HubspotDealCreationSectionProps> = ({
	isHubspotEnabled,
	isConnected,
	selectedDealCreationTrigger,
	setSelectedDealCreationTrigger,
	effectiveTrigger,
}) => {
	const { t } = useTranslation();
	const tsSettings = (key: string) => t(`list.settings.${key}`);

	if (!isHubspotEnabled || !isConnected) {
		return null;
	}

	return (
		<div className="flex flex-col w-full mt-8">
			<div className="flex flex-col gap-2 w-full mb-4">
				<div className="text-ssm font-medium text-text">
					{tsSettings("hubspot.dealCreationTrigger.title")}{" "}
					<Information information={tsSettings("hubspot.dealCreationTrigger.description")} />
				</div>
			</div>
			<Dropdown
				data={[
					{
						title: tsSettings("hubspot.dealCreationTrigger.INHERIT"),
						id: HubspotDealCreationTriggerWithInherit.INHERIT,
					},
					{
						title: tsSettings("hubspot.dealCreationTrigger.DISABLED"),
						id: HubspotDealCreationTriggerWithInherit.DISABLED,
					},
					{
						title: tsSettings("hubspot.dealCreationTrigger.ON_RESPONSE"),
						id: HubspotDealCreationTriggerWithInherit.ON_RESPONSE,
					},
					{
						title: tsSettings("hubspot.dealCreationTrigger.ON_POSITIVE_RESPONSE"),
						id: HubspotDealCreationTriggerWithInherit.ON_POSITIVE_RESPONSE,
					},
				]}
				defaultValue={
					selectedDealCreationTrigger
						? {
								id: selectedDealCreationTrigger,
								title: tsSettings(`hubspot.dealCreationTrigger.${selectedDealCreationTrigger}`),
							}
						: undefined
				}
				floating={true}
				handleSelect={(value: DropdownAutoCompleteItem) => {
					setSelectedDealCreationTrigger(value.id as HubspotDealCreationTriggerWithInherit);
				}}
			/>
			{selectedDealCreationTrigger === HubspotDealCreationTriggerWithInherit.INHERIT &&
				effectiveTrigger && (
					<div className="text-ssm text-text-meta mt-2">
						{tsSettings("hubspot.dealCreationTrigger.inheritedFrom")}:{" "}
						{tsSettings(`hubspot.dealCreationTrigger.${effectiveTrigger}`)}
					</div>
				)}
		</div>
	);
};
